import { v4 as generateUuid } from 'uuid';
import { uuidToString } from './uuid';

export function generateRequestId(): string {
  return uuidToString(generateUuid());
}

export const HEADER_REQUEST_ID = 'x-request-id';
export const HEADER_AKAMAI_CDN_ACL_BYPASS = 'x-aka-secret';
export const HEADER_STACK_ID = 'x-stack-id';
export const HEADER_CHEWY_INTERNAL = 'x-chewy-internal';

export const COOKIE_PERSONALIZATION_ID = 'pid';
export const COOKIE_TICKET = 'ticket';
export const COOKIE_AUTH_TOKEN = 'at';
export const COOKIE_LBGROUP = 'lbGroup';
export const COOKIE_ABTESTOVERRIDES = 'experimentOverrides';
export const COOKIE_CONTENT_PREVIEW = 'chewy-overrides.content-preview';
